import React from 'react';
import { LogIn, LogOut, Clock, AlertCircle, Ban, CheckCircle2 } from 'lucide-react';
import { cn } from '../../lib/utils';

const STATE_META = {
  entered: { label: 'Entered', icon: LogIn, className: 'border-blue-200 bg-blue-50 text-blue-700' },
  exited: { label: 'Exited', icon: LogOut, className: 'border-blue-200 bg-blue-50 text-blue-700' },
  executed: { label: 'Executed', icon: CheckCircle2, className: 'border-emerald-200 bg-emerald-50 text-emerald-700' },
  waiting: { label: 'Waiting', icon: Clock, className: 'border-sky-200 bg-sky-50 text-sky-700' },
  failed: { label: 'Failed', icon: AlertCircle, className: 'border-red-200 bg-red-50 text-red-700' },
  skipped: { label: 'Skipped', icon: Ban, className: 'border-amber-200 bg-amber-50 text-amber-700' },
};

export function getPathBorderClass(pathState) {
  if (!pathState) return '';
  return 'border-emerald-500 ring-1 ring-emerald-200';
}

const ExecutionPathStepBadge = ({ state }) => {
  if (!state) return null;
  const meta = STATE_META[state] || STATE_META.executed;
  const Icon = meta.icon;
  return (
    <span
      className={cn(
        'absolute -top-2 left-3 z-10 inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold shadow-sm',
        meta.className,
      )}
      data-testid={`execution-path-badge-${state}`}
    >
      <Icon size={10} />
      {meta.label}
    </span>
  );
};

export default ExecutionPathStepBadge;
